// extracted by mini-css-extract-plugin
export default {"Vcard":"VirtualAccount_Vcard__XdtGW","VAcctTxt":"VirtualAccount_VAcctTxt__2QiMg","VFundTxt":"VirtualAccount_VFundTxt__C6d-K","VBank":"VirtualAccount_VBank__4iom+"};